import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { useBatchAddOperations } from 'hooks/batchOperations';

const PERSONAL_OVERVIEW_CONFIG = {
  key: 'addPersonalKeyObjectives',
  invalidate: 'personalOverview',
  resource: SPARK_RESOURCE_TYPES.PERSONAL_OVERVIEW_KEY_OBJECTIVES,
  attributeKey: 'personalOverviewID',
};
const COMPANY_OVERVIEW_CONFIG = {
  key: 'addCompanyKeyObjectives',
  invalidate: 'companyOverview',
  resource: SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_KEY_OBJECTIVES,
  attributeKey: 'companyOverviewID',
};

type mutationVariables = {
  keyObjectivesIDs: string[];
};

export function useBatchAddKeyObjectives(
  type:
    | typeof SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_KEY_OBJECTIVES
    | typeof SPARK_RESOURCE_TYPES.PERSONAL_OVERVIEW_KEY_OBJECTIVES,
  overviewID: string | undefined
) {
  const config =
    type === SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_KEY_OBJECTIVES
      ? COMPANY_OVERVIEW_CONFIG
      : PERSONAL_OVERVIEW_CONFIG;

  const queryClient = useQueryClient();
  const { mutateAsync: addBatchSparkImages } = useBatchAddOperations();

  const addKeyObjectives = ({ keyObjectivesIDs }: mutationVariables) => {
    if (!overviewID) {
      return Promise.reject('overviewID can not be null');
    }
    const keyObjectivesArray = keyObjectivesIDs.map((keyObjectiveID) => ({
      type: config.resource,
      attributes: {
        [config.attributeKey]: overviewID,
        keyObjectiveID: +keyObjectiveID,
      },
    }));

    return addBatchSparkImages(keyObjectivesArray);
  };

  return useMutation(config.key, addKeyObjectives, {
    onSuccess: () => {
      queryClient.invalidateQueries([config.invalidate, overviewID]);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Post key objectives: ${error.message}`);
      }
    },
  });
}
